<div class="container_width w-full flex flex-column gap-5 mx-auto">
  <div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
    <div class="md:col-5 lg:col-4 col-12 p-0 md:pr-3 flex flex-column gap-4">
      <div class="flex flex-column gap-3">
        <b class="text-xl font-bold">My Colleges</b>
        <div class="flex flex-column gap-2">
          <p-button *ngFor="let institute of myInstitutes;" styleClass="essay_btn"
            (click)="loadInstituteCheckList(institute)"
            class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
            <span>{{institute.instituteName}}</span>
            <i class="pi pi-angle-right"></i>
          </p-button>
        </div>
        <div class="w-full mt-2">
          <a (click)="openAdditionalInfo()"
            class="add_inf cursor-pointer w-full flex align-items-center justify-content-between py-3 px-4 border-round-lg text-left font-normal text-base"
            style="color: #111111;">Task <i class="pi pi-angle-right"></i></a>
        </div>
      </div>
    </div>

    <div *ngIf="currentSelectedTab===selectedTab.checkList" class="md:col-7 lg:col-8 col-12 p-0 md:pl-3">

      <div *ngIf="myInstitutes && myInstitutes.length==0 && !isLoading"
        class="w-full flex flex-column gap-3 p-3 border-round-lg border-dashed border-2"
        style="border-color: #F6B801; background-color: #FFF8E6;">
        <h2 class="text-center font-medium text-xl flex align-items-center gap-2 justify-content-center"
          style="color: #111111;"><b>No Institute Choosen</b>
        </h2>
      </div>

      <div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
          animationDuration=".5s"></p-progressSpinner>
      </div>

      <div *ngIf="!isLoading && applyingForLevel == null"
        class="flex gap-4 align-items-center justify-content-center py-5">
        <p-messages class="w-full" severity="warn" [closable]="false">
          <ng-template pTemplate>
            <div class="ml-2 gap-4 w-full">
              Degree preference is not submitted
            </div>
            <a (click)="navigateToCompleteProfile()" class="links_right cursor-pointer white-space-nowrap">
              <small class="text-sm">Application Form</small>
              <i class="pi pi-arrow-right text-xs"></i>
            </a>
          </ng-template>
        </p-messages>
      </div>

      <div *ngIf="!isLoading && applyingForLevel!==null" class="flex flex-column gap-4">

        <div *ngIf="selectedInstitute && selectedInstitute!=null" class="w-full relative bg-white flex"
          style="border-radius: 12px; border: 1px solid #E8EDF2; box-shadow: 0 1px 4px rgba(0,0,0,0.06); overflow: hidden;">

          <div style="width: 6px; background-color: #CDD12A; flex-shrink: 0;"></div>

          <div class="flex-1 relative">

            <div style="position: absolute; right: 16px; top: 16px; z-index: 99;">
              <p-button icon="pi pi-trash" tooltipPosition="bottom" pTooltip="Remove College" styleClass="trash"
                (onClick)="toggleMyInstitute()" class="trashw" />
            </div>

            <div class="flex align-items-center gap-3 p-4 pb-3">
              <div class="w-5rem h-5rem overflow-hidden border-circle flex-shrink-0">
                <img
                  [src]="selectedInstitute.logo ? selectedInstitute.logo : '../../../assets/images/logo-placeholder.png'"
                  alt="" class="w-full h-full" style="object-fit: cover;">
              </div>
              <div class="flex-1 flex flex-column gap-1">
                <a [routerLink]="['/portal/', selectedInstitute.id, 'institute']"
                  class="text-left font-bold text-xl cursor-pointer" style="color: #1E293B;">
                  {{selectedInstitute.instituteName}}
                </a>
                <p class="text-base" style="color: #64748B;">
                  {{selectedInstitute.city + ', ' + selectedInstitute.country}}
                </p>
              </div>
              <div class="flex flex-column align-items-end" style="margin-right: 3rem;">
                <b class="font-bold text-xl" style="color: #1E293B;">
                  {{ daysLeft && daysLeft > 0 ? daysLeft : '0' }} Days Left
                </b>
                <p class="text-sm" style="color: #94A3B8;">
                  Submit your application before
                  {{selectedInstitute.applicationDeadlineRegularDecision | date: 'dd MMM yyyy'}}
                </p>

                <div *ngIf="selectedInstitute.mentorDeadline || !hasApprovedMentor" 
                  class="mt-2 py-2 px-3 border-round-md flex align-items-center justify-content-between gap-2" 
                  [style.background-color]="hasApprovedMentor ? '#F4F8D3' : '#E8F5E9'"
                  style="border: 1px solid rgba(0,0,0,0.05);">
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-clock" [style.color]="hasApprovedMentor ? '#4B5320' : '#2E7D32'"></i>
                    <span class="text-sm font-semibold" [style.color]="hasApprovedMentor ? '#4B5320' : '#2E7D32'">
                      {{ hasApprovedMentor ? 'Mentor Deadline' : 'Student Deadline' }}: 
                      {{ selectedInstitute.mentorDeadline ? (selectedInstitute.mentorDeadline | date: 'dd MMM yyyy') : 'Not Set' }}
                      <span *ngIf="selectedInstitute.mentorDeadline" class="ml-1 opacity-70">
                        ({{ mentorDaysLeft !== null && mentorDaysLeft > 0 ? mentorDaysLeft.toString() : '0' }} days left)
                      </span>
                    </span>
                  </div>
                  <p-button *ngIf="!hasApprovedMentor" icon="pi pi-pencil" 
                    styleClass="p-button-text p-button-sm p-0" 
                    [pTooltip]="selectedInstitute.mentorDeadline ? 'Edit Deadline' : 'Add Deadline'" 
                    tooltipPosition="bottom"
                    (onClick)="openDeadlineDialog()" />
                </div>
              </div>
            </div>

            <hr style="border: none; border-top: 1px solid #F1F5F9; margin: 0;" />
            <div class="p-4 pt-3">
              <div class="flex justify-content-between align-items-start mb-3">
                <div class="flex flex-column gap-1">
                  <span class="text-xs font-bold uppercase" style="color: #94A3B8; letter-spacing: 0.08em;">Selected
                    Course</span>
                  <div class="flex align-items-center mt-1" style="gap: 1rem;">
                    <span class="text-lg font-bold" style="color: #1E293B;">
                      {{ selectedInstitute.courseName || studentInstituteCheckList?.courseName || 'N/A' }}
                    </span>
                    <span style="color: #CBD5E1;">•</span>
                    <span class="text-base" style="color: #64748B;">
                      {{ getCourseLevelLabel(selectedInstitute.courseLevel) || 'N/A' }}
                    </span>
                  </div>
                </div>
                <p-button icon="pi pi-pencil" tooltipPosition="bottom" pTooltip="Edit Program"
                  styleClass="edit_pencil_btn" (onClick)="onEditInstitute(selectedInstitute)" />
              </div>

              <div class="flex flex-wrap gap-5 mb-3">
                <div class="flex gap-3 align-items-center" style="margin-right: 12rem;">
                  <div class="flex align-items-center justify-content-center border-round-lg"
                    style="width: 44px; height: 44px; background-color: #F1F5F9; flex-shrink: 0;">
                    <i class="pi pi-calendar" style="color: #64748B;"></i>
                  </div>
                  <div class="flex flex-column gap-1">
                    <span class="text-xs font-bold uppercase" style="color: #94A3B8; letter-spacing: 0.08em;">Intake
                      Year</span>
                    <span class="font-bold" style="color: #1E293B;">
                      {{ selectedInstitute.inTakeYear || 'N/A' }}
                    </span>
                  </div>
                </div>

                <div class="flex gap-3 align-items-center">
                  <div class="flex align-items-center justify-content-center border-round-lg"
                    style="width: 44px; height: 44px; background-color: #F1F5F9; flex-shrink: 0;">
                    <i class="pi pi-graduation-cap" style="color: #64748B;"></i>
                  </div>
                  <div class="flex flex-column gap-1">
                    <span class="text-xs font-bold uppercase" style="color: #94A3B8; letter-spacing: 0.08em;">Course
                      Level</span>
                    <span class="font-bold" style="color: #1E293B;">
                      {{ getCourseLevelLabel(selectedInstitute.courseLevel) || 'N/A' }}
                    </span>
                  </div>
                </div>
              </div>

              <span class="text-xs font-bold uppercase"
                style="background-color: #F4F8D3; color: #4B5320; border-radius: 20px; padding: 6px 14px; border: 1px solid #CDD12A; letter-spacing: 0.06em;">
                Application In Progress
              </span>
            </div>

          </div>
        </div>

        <form [formGroup]="checklistForm" (ngSubmit)="saveStudentChecklist()">
          <div *ngIf="instituteCheckList" class="w-full flex flex-column gap-4">
            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #FCFDF0; border-color: #CDD12A;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center justify-content-between gap-2">
                  <b class="text-xl font-medium">Essay</b>
                  <a routerLink="/portal/essay-pilot" class="links_right cursor-pointer">
                    <small class="text-sm">Essay Pilot</small>
                    <i class="pi pi-arrow-right text-xs"></i>
                  </a>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let essayPilot of instituteCheckList.essayPilot;">
                    <p-checkbox [value]="essayPilot" [inputId]="essayPilot" formControlName="essayPilot"
                      [label]="essayPilot" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('essayPilot')?.invalid && (submitted || checklistForm.get('essayPilot')?.touched)">
                  Select Essay Pilot
                </small>
              </div>
              <div class="w-full flex flex-column gap-2 pt-3" style="border-top: 1px solid #ddd;">
                <b class="text-xl font-medium">LOR</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let lor of instituteCheckList.loRs;">
                    <p-checkbox [value]="lor" [inputId]="lor" formControlName="lORs" [label]="lor" styleClass="checkbox"
                      labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('lORs')?.invalid && (submitted || checklistForm.get('lORs')?.touched)">
                  Select LORs
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #F8F7FF; border-color: #B3B2DA;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center justify-content-between gap-2">
                  <b class="text-xl font-medium">Personal Documents</b>
                  <a routerLink="/portal/document-repository" class="links_right">
                    <small class="text-sm">Document Repositery</small>
                    <i class="pi pi-arrow-right text-xs"></i>
                  </a>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let personalDocument of instituteCheckList.personalDocuments;">
                    <p-checkbox [value]="personalDocument" [inputId]="personalDocument"
                      formControlName="personalDocuments" [label]="personalDocument" styleClass="checkbox"
                      labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('personalDocuments')?.invalid && (submitted || checklistForm.get('personalDocuments')?.touched)">
                  Select Personal Documents
                </small>
              </div>
              <div class="w-full flex flex-column gap-2 pt-3" style="border-top: 1px solid #ddd;">
                <b class="text-xl font-medium">Test Scores</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let testScore of instituteCheckList.testScores;">
                    <p-checkbox [value]="testScore" [inputId]="testScore" formControlName="testScores"
                      [label]="testScore" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('testScores')?.invalid && (submitted || checklistForm.get('testScores')?.touched)">
                  Select Test Scores
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #FCFDF0; border-color: #CDD12A;">
              <div class="w-full flex flex-column gap-2">
                <b class="text-xl font-medium">Financial Aid/Scholarship</b>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let financialAid of instituteCheckList.financialAid;">
                    <p-checkbox [value]="financialAid" [inputId]="financialAid" formControlName="financialAids"
                      [label]="financialAid" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('financialAids')?.invalid && (submitted || checklistForm.get('financialAids')?.touched)">
                  Select Financial Aid
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-3 border-1 border-round-lg p-3"
              style="background-color: #F8F7FF; border-color: #B3B2DA;">
              <div class="w-full flex flex-column gap-2">
                <div class="flex align-items-center justify-content-between gap-2">
                  <b class="text-xl font-medium">Application Form</b>
                  <a routerLink="/portal/application-form" class="links_right">
                    <small class="text-sm">Application Form</small>
                    <i class="pi pi-arrow-right text-xs"></i>
                  </a>
                </div>
                <div class="w-full flex align-items-center flex-wrap gap-2">
                  <div *ngFor="let appnForm of instituteCheckList.applicationForms;">
                    <p-checkbox [value]="appnForm" [inputId]="appnForm" formControlName="applicationForms"
                      [label]="appnForm" styleClass="checkbox" labelStyleClass="checkbox_label" class="relative" />
                  </div>
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="checklistForm.get('applicationForms')?.invalid && (submitted || checklistForm.get('applicationForms')?.touched)">
                  Select Form
                </small>
              </div>
            </div>

            <div class="flex align-items-center justify-content-end">
              <p-button label="Save" [loading]="isSaving" class="w-full sm:w-12rem" styleClass="save_btn"
                (onClick)="saveStudentChecklist()" />
            </div>
          </div>
        </form>
      </div>
    </div>

    <app-additional-information class="md:col-7 lg:col-8 col-12 p-0 md:pl-3"
      *ngIf="currentSelectedTab === selectedTab.additionalInfo" [infoType]="additionalInfoType.CheckList">
    </app-additional-information>
  </div>
</div>


<p-dialog header="Select Program" [(visible)]="displayCourseDialog" [modal]="true" [style]="{width: '450px'}"
  [draggable]="false" [resizable]="false" (onHide)="cancelCourseDialog()">
  <div class="flex flex-column gap-3 py-2">
    <p class="text-bluegray-600">Please select the program you are applying for at
      <b>{{selectedInstitute?.instituteName}}</b>
    </p>

    <div *ngIf="loadingCourses" class="flex justify-content-center py-4">
      <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
    </div>

    <div *ngIf="!loadingCourses && courses.length > 0" class="flex flex-column gap-2">
      <div class="mb-3">
        <label class="font-medium text-sm mb-1 block">Course Level</label>
        <p-dropdown [options]="courseLevelOptions" [(ngModel)]="selectedCourseLevel" optionLabel="label"
          optionValue="value" placeholder="Select Course Level" styleClass="w-full" appendTo="body" [showClear]="true"
          (onChange)="onCourseLevelChange()" />
      </div>

      <div class="mb-3">
        <label class="font-medium text-sm mb-1 block">Course</label>
        <p-dropdown [options]="filteredCourses" [(ngModel)]="selectedCourse" optionLabel="courseName" dataKey="id"
          placeholder="Select Course" styleClass="w-full" [appendTo]="'body'" [filter]="true" filterBy="courseName"
          (onChange)="onCourseSelectionChange()">
          <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="flex flex-column" *ngIf="selectedOption">
              <span class="font-semibold">{{selectedOption.courseName}}</span>
              <small class="text-bluegray-500">{{selectedOption.courseLevel}}</small>
            </div>
          </ng-template>
          <ng-template let-course pTemplate="item">
            <div class="flex flex-column">
              <span class="font-semibold">{{course.courseName}}</span>
              <small class="text-bluegray-500">{{course.courseLevel}}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div>
        <label class="font-medium text-sm mb-1 block">Intake Year</label>
        <p-dropdown [options]="intakeYears" [(ngModel)]="selectedIntakeYear" placeholder="Select Intake Year"
          styleClass="w-full" appendTo="body" [showClear]="true" />
      </div>

    </div>

    <div *ngIf="!loadingCourses && courses.length === 0" class="text-center py-4 text-pink-600">
      <i class="pi pi-exclamation-circle text-2xl mb-2"></i>
      <p>No courses found for this institute.</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" (click)="cancelCourseDialog()"
        styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Update" icon="pi pi-check" (click)="confirmCourseUpdate()" [disabled]="!selectedCourse"
        styleClass="p-button-primary"></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="selectedInstitute?.mentorDeadline ? 'Edit Deadline' : 'Add Deadline'" [(visible)]="displayDeadlineDialog" [modal]="true" [style]="{width: '400px'}"
  [draggable]="false" [resizable]="false">
  <div class="flex flex-column gap-3 py-2">
    <p class="text-bluegray-600">Set a personal deadline for your application to <b>{{selectedInstitute?.instituteName}}</b>.</p>
    
    <div class="field flex flex-column gap-2">
      <label for="deadline" class="font-medium">Select Date</label>
      <p-calendar id="deadline" [(ngModel)]="selectedDeadline" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" 
        [minDate]="today" placeholder="Choose a date" styleClass="w-full" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" (click)="displayDeadlineDialog = false"
        styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Save" icon="pi pi-check" (click)="saveDeadline()" [loading]="isSavingDeadline"
        styleClass="p-button-primary"></p-button>
    </div>
  </ng-template>
</p-dialog>